import React, {useEffect, useRef, useState} from 'react';
import {Button} from 'primereact/button';
import {Column} from 'primereact/column';
import {DataTable} from 'primereact/datatable';
import {MultiSelect} from 'primereact/multiselect';
import {Toast} from 'primereact/toast';
import {useAppDispatch, useAppSelector} from 'redux/hooks'
import {setEditType} from "redux/actions/actions";
import {ConfirmDialog} from "primereact/confirmdialog";
import {Paginator} from "primereact/paginator";
import {classNames} from "primereact/utils";
import {Dialog} from "primereact/dialog";
import {getAudioControlPermissions} from "../../../../redux/permissions/permissionsUtils";
import AudioControlListNav from "../AudioControlListNav";
import AudioControlDialog from "../AudioControlDialog";
import AudioControlListDetails from "./AudioControlListDetails";
import {
    archiveOrUnArchiveAudioControlById,
    copyAudioControlById,
    getAllAudioControlsWithPagination,
    getAudioControlById,
} from "../../../../redux/api/apiAudioControl";
import {
    setArchiveAudioControlTableToggle,
    setAudioControlCurrentPage,
    setAudioControlCurrentPageSize,
    setAudioControlDialogVisible,
    setAudioControlErrorField,
    setSelectedAudioControlIndex,
} from "../../../../redux/actions/actionsAudioControl";
import {getUsersManagerUserBranchesData} from "../../../../redux/api/apiUsersList";

const AudioControlList = () => {
    const dispatch = useAppDispatch();
    const clearFilters = useAppSelector(state => state.AudioControlListReducer.clearFilters);
    const audioControlsList = useAppSelector(state => state.AudioControlListReducer.audioControlsList);
    const pagination = useAppSelector(state => state.AudioControlListReducer.pagination);
    const paginationPage = useAppSelector(state => state.AudioControlListReducer.paginationPage);
    const paginationSize = useAppSelector(state => state.AudioControlListReducer.paginationSize);
    const archiveTableToggle = useAppSelector(state => state.AudioControlListReducer.archiveAudioControlTableToggle);
    const loader = useAppSelector(state => state.AudioControlListReducer.loading);
    const [mobileVisible, setMobileVisible] = useState<boolean>(false);
    const toast = useRef<Toast>(null);
    const [first, setFirst] = useState(0);
    const [orderBy, setOrderBy] = useState<any>(null);
    const [isDescFilter, setIsDescFilter] = useState<boolean>(true);
    const [filterId, setFilterId] = useState<any>(null);
    const [filterName, setFilterName] = useState<any>(null);
    const [filterActive, setFilterActive] = useState<any>(null);
    const [sortOrder, setSortOrder] = useState<number>(0);
    const rolesVision = useAppSelector(state => state.RolesReducer.rolesVision) as unknown as Record<string, string[]>;
    const audioControlPermissions = getAudioControlPermissions(rolesVision);
    const [page, setPage] = useState<any>(1);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const [selectedRowData, setSelectedRowData] = useState<any | null>(null);
    const jwtToken = useAppSelector(state => state.UsersReducer.userData.jwtToken);
    const [visibleArchiveMessage, setVisibleArchiveMessage] = useState<boolean>(false);
    const [visibleUnArchiveMessage, setVisibleUnArchiveMessage] = useState<boolean>(false);
    const [visibleCopyMessage, setVisibleCopyMessage] = useState<boolean>(false);
    const [archiveItemId, setArchiveItemId] = useState<number>(0);
    const [copyItemId, setCopyItemId] = useState<number>(0);
    const activeClick = useAppSelector(state => state.UsersListReducer.activeClick);
    const [sortData, setSortData] = useState<any>({
        isArchived: !archiveTableToggle,
        pageNumber: page ? page : paginationPage,
        pageSize: paginationSize,
        sort: {
            orderBy: orderBy ? orderBy : "Id",
            isDesc: isDescFilter
        }
    });

    const {
        create: hasCreatePermission,
        update: hasUpdatePermission,
        delete: hasDeletePermission,
    } = audioControlPermissions;

    const isActive = [
        {name: 'Активна', value: true},
        {name: 'Не активна', value: false},
    ];

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {
        dispatch(setAudioControlCurrentPage(1));
    }, []);

    useEffect(() => {
        dispatch(getUsersManagerUserBranchesData(jwtToken?.jwtToken));
    }, []);

    useEffect(() => {
        dispatch(setAudioControlCurrentPageSize(10));
        dispatch(setArchiveAudioControlTableToggle(true));
    }, []);

    const resetTableHorizontalScroll = () => {
        const scrollableBody = document.querySelector('.p-datatable-wrapper');
        if (scrollableBody) {
            scrollableBody.scrollTop = 0;
            scrollableBody.scrollLeft = 0;
        }
    };

    useEffect(() => {
        let filter: { key: string; value: string }[] = [];
        const dataSort: any = {
            isArchived: !archiveTableToggle,
            pageNumber: page ? page : paginationPage,
            pageSize: paginationSize,
            sort: {
                orderBy: orderBy ? orderBy : "Id",
                isDesc: isDescFilter
            }
        }
        if (filterId?.value) {
            filter.push(filterId);
        }
        if (filterName?.value) {
            filter.push(filterName);
        }
        if (filter) {
            dataSort['filter'] = filter;
        }
        if (filterActive && filterActive.length) {
            if (filterActive.length !== 2) {
                filterActive.forEach((item: any) => {
                    dataSort['isActive'] = item.value;
                    if (item.value === "true") {
                        dataSort['isActive'] = true;
                    } else if (item.value === "false") {
                        dataSort['isActive'] = false;
                    }
                });
            }
        } else {
            if ("isActive" in dataSort) {
                delete dataSort.isActive;
            }
        }
        resetTableHorizontalScroll();
        dispatch(getAllAudioControlsWithPagination(dataSort, jwtToken?.jwtToken));
        setSortData(dataSort);
        setPage(null);
    }, [paginationPage, paginationSize, archiveTableToggle, orderBy, filterActive, isDescFilter, filterId, filterName]);

    useEffect(() => {
        if (activeClick?.item === "/audio_control" && activeClick?.from === '#/audio_control') {
            dispatch(getAllAudioControlsWithPagination(sortData, jwtToken?.jwtToken));
            resetTableHorizontalScroll();
            if (selectedRowData) {
                dispatch(getAudioControlById(selectedRowData, jwtToken?.jwtToken));
            }
        }
    }, [activeClick]);

    useEffect(() => {
        setSelectedRowData(null);
    }, [archiveTableToggle, paginationPage, paginationSize]);

    useEffect(() => {
        setFirst(0);
        dispatch(setAudioControlCurrentPageSize(10));
        dispatch(setAudioControlCurrentPage(1));
    }, [archiveTableToggle]);

    const confirmArchiveOrUnarchive = () => {
        if (!hasDeletePermission) {
            return;
        }
        setSelectedRowData(null);
        dispatch(archiveOrUnArchiveAudioControlById(archiveItemId, jwtToken?.jwtToken, sortData));
    }

    const confirmCopy = () => {
        if (!hasCreatePermission) {
            return;
        }
        setSelectedRowData(null);
        dispatch(copyAudioControlById(copyItemId, jwtToken?.jwtToken, sortData));
    }

    const actionTemplate = (rowData: any) => {
        const archiveToastShow = (id: number) => {
            setVisibleArchiveMessage(true);
            setArchiveItemId(id);
        }

        const unArchiveToastShow = (id: number) => {
            setVisibleUnArchiveMessage(true);
            setArchiveItemId(id);
        }

        const copyToastShow = (id: number) => {
            setVisibleCopyMessage(true);
            setCopyItemId(id);
        }

        return (
            <div className="flex">
                <div className="controls-buttons">
                    {archiveTableToggle && hasCreatePermission && (
                        <Button
                            type="button"
                            className="p-button-text p-button-icon"
                            icon="pi pi-copy"
                            aria-label="Копіювати анкету"
                            onClick={(e) => {
                                e.stopPropagation();
                                e.preventDefault();
                                copyToastShow(rowData.id);
                            }}
                        />
                    )}
                </div>
                {archiveTableToggle && hasDeletePermission && (
                    <Button
                        className="p-button-text p-button-icon"
                        icon="pi pi-trash"
                        aria-label="Архівувати анкету"
                        onClick={(e) => {
                            e.stopPropagation();
                            e.preventDefault();
                            archiveToastShow(rowData.id);
                        }}
                    />
                )}
                {!archiveTableToggle && hasDeletePermission && (
                    <Button
                        className="p-button-text p-button-icon"
                        icon="pi pi-folder-open"
                        aria-label="Відновити анкету"
                        onClick={(e) => {
                            e.stopPropagation();
                            e.preventDefault();
                            unArchiveToastShow(rowData.id);
                        }}
                    />
                )}
            </div>
        );
    };

    const nameBodyTemplate = (rowData: any) => {
        let itemName = '';
        audioControlsList.map((item: any) => {
            if (item.id === rowData.id) {
                let name = item.name;
                const truncateWithEllipses = (text: string, max: number) => {
                    return text.substr(0, max - 1) + (text.length > max ? '...' : '');
                }
                if (name) {
                    itemName = truncateWithEllipses(name, 41)
                }
            }
        });
        return <span>{itemName}</span>;
    };

    const isActiveFilterTemplate = (options: any) => {
        return (
            <>
                <div className="mb-3 text-bold">Оберіть</div>
                <MultiSelect
                    filter
                    value={options.value}
                    options={isActive}
                    optionLabel="name"
                    optionValue="value"
                    onChange={(e: any) => options.filterCallback(e.value)}
                    placeholder="нічого не обрано"
                    className="p-column-filter"
                />
            </>
        );
    };

    const filterClearTemplate = (options: any) => {
        return <Button type="button" icon="pi pi-times" onClick={options.filterClearCallback} className="p-button-secondary"></Button>;
    }

    const filterApplyTemplate = (options: any) => {
        return <Button type="button" icon="pi pi-check" onClick={options.filterApplyCallback} className=""></Button>
    }

    const dataTableRef = useRef<DataTable | any>(null);

    const handleReset = () => {
        dataTableRef?.current?.reset();
        customFilter();
        setSortOrder(0);
        dispatch(setAudioControlCurrentPageSize(10));
        dispatch(setAudioControlCurrentPage(1));
        setFirst(0);
    };

    const onPageChange = (event: any) => {
        setFirst(event.first);
        dispatch(setAudioControlCurrentPage(event.page + 1));
        dispatch(setAudioControlCurrentPageSize(event.rows));
        setSortData((prev: any) => ({...prev, pageNumber: event.page + 1, pageSize: event.rows}));
    };

    const customSort = (event: any) => {
        const handleAction = (sortField: string) => {
            let newOrderBy: string;
            switch (sortField) {
                case 'Id':
                    newOrderBy = 'Id';
                    break;
                case 'Name':
                    newOrderBy = 'Name';
                    break;
                case 'IsActive':
                    newOrderBy = 'IsActive';
                    break;
                default:
                    return;
            }
            setOrderBy(newOrderBy);
            setIsDescFilter(!isDescFilter);
            setSortOrder(sortOrder === 1 ? -1 : 1);
        };
        handleAction(event.sortField);
    };

    const customFilter = (event?: any) => {
        if (event) {
            const {id, name, isActive: isActiveFilter} = event.filters;
            setFilterId(id ? {key: 'Id', value: id.constraints[0].value} : null);
            setFilterName(name ? {key: 'Name', value: name.constraints[0].value} : null);
            if (isActiveFilter.value) {
                setFilterActive(isActiveFilter.value.map((item: any) => ({key: 'IsActive', value: item})));
            } else {
                setFilterActive(null);
            }
        } else {
            setFilterId(null);
            setFilterName(null);
            setOrderBy(null);
            setFilterActive(null);
            setIsDescFilter(true);
        }
    };

    const renderHeader = (field: string, sortField: string) => {
        const sorted = sortField === orderBy;
        const sortIcon = classNames('p-sortable-column-icon', {
            'pi pi-sort-amount-up-alt': sorted && sortOrder === 1,
            'pi pi-fw pi-sort-amount-down': sorted && sortOrder === -1,
            'pi pi-fw pi-sort-alt': sortOrder === 0 || !sorted
        });

        return (
            <div className="flex align-items-center sticky top-0" onClick={() => customSort({'sortField': sortField})}>
                {field} <i className={sortIcon}></i>
            </div>
        );
    };

    const isMobile = () => {
        return windowWidth <= 1248;
    }

    const openEditDialog = () => {
        dispatch(setAudioControlDialogVisible(true));
        dispatch(getAudioControlById(selectedRowData, jwtToken?.jwtToken));
        dispatch(setAudioControlErrorField(null));
        setSelectedRowData(null);
        if (hasUpdatePermission) {
            dispatch(setEditType(true));
        } else {
            dispatch(setEditType(false));
        }
    }

    const dialogHeader = () => {
        return <>
            <div className="flex align-items-center justify-content-end m-0 p-0 mr-1">
                <Button className="p-dialog-header-icon p-dialog-header-close p-link border-noround	outline-none shadow-none h-full justify-content-end" onClick={() => {
                    openEditDialog();
                }}>
                    <span className={classNames('', {
                        'pi pi-pencil': archiveTableToggle && hasUpdatePermission,
                        'pi pi-eye': !archiveTableToggle || !hasUpdatePermission
                    })}></span></Button>
            </div>
        </>
    }

    return (
        <div className="layout-dashboard">
            <Toast ref={toast}/>
            <div className="">
                <div className="flex col-12 md:col-12 p-0 flex-wrap">
                    <div className={classNames('card widget-table col-12 transition-duration-300 monitoring-table align-self-start m-0 mr-0', {'mb-4': selectedRowData && !isMobile(), 'md:col-12': !selectedRowData})}>
                        <AudioControlListNav handleReset={handleReset} setSelectedRowData={setSelectedRowData}/>
                        <DataTable
                            ref={dataTableRef}
                            scrollable
                            scrollHeight={(selectedRowData) && !isMobile() ? '35vh' : '70vh'}
                            className="p-datatable-customers monitoring-table"
                            value={audioControlsList}
                            dataKey="id"
                            filters={clearFilters}
                            rowsPerPageOptions={[10, 15, 25, 50]}
                            rowHover={false}
                            selectionMode="single"
                            selection={selectedRowData}
                            onSort={customSort}
                            onFilter={customFilter}
                            emptyMessage="Нічого не знайдено"
                            responsiveLayout='scroll'
                            onRowClick={(e) => {
                                setSelectedRowData(e.data.id);
                                dispatch(getAudioControlById(e.data.id, jwtToken?.jwtToken));
                                dispatch(setSelectedAudioControlIndex(e.data.id));
                                setMobileVisible(true);
                                if (isMobile()) {
                                    setMobileVisible(true);
                                }
                            }}
                            loading={loader}
                            rowClassName={(rowData: any) =>
                                rowData?.id === selectedRowData ? 'p-highlight' : ''
                            }
                        >
                            <Column
                                field="id"
                                filterField="id"
                                header={renderHeader('ID', 'Id')}
                                showFilterMatchModes={false}
                                showFilterMenuOptions={false}
                                filterPlaceholder="Введіть ID"
                                filter
                                sortable
                                className={classNames('', {'active-header-column': orderBy === 'Id'})}
                                body={(data) => data.id}
                                filterClear={filterClearTemplate}
                                filterApply={filterApplyTemplate}
                                style={{cursor: 'pointer', width: '10%', minWidth: '90px'}}
                            />
                            <Column
                                field="name"
                                filterField="name"
                                header={renderHeader('Назва', 'Name')}
                                className={classNames('', {'active-header-column': orderBy === 'Name'})}
                                showFilterMatchModes={false}
                                showFilterMenuOptions={false}
                                filterPlaceholder="Введіть назву"
                                filter
                                sortable
                                body={nameBodyTemplate}
                                filterClear={filterClearTemplate}
                                filterApply={filterApplyTemplate}
                                style={{cursor: 'pointer', width: '100%', minWidth: '150px'}}
                            />
                            <Column
                                field="isActive"
                                filterField="isActive"
                                header={renderHeader('Стан', 'IsActive')}
                                className={classNames('', {'active-header-column': orderBy === 'IsActive'})}
                                showFilterMatchModes={false}
                                showFilterMenuOptions={false}
                                filter
                                body={data => data?.isActive ? 'Активна' : 'Не активна'}
                                sortable
                                filterClear={filterClearTemplate}
                                filterApply={filterApplyTemplate}
                                filterElement={isActiveFilterTemplate}
                                style={{cursor: 'pointer', width: '100%', minWidth: '150px'}}
                            />
                            <Column header="Дія" style={{cursor: 'pointer', width: '10%', minWidth: '120px'}} body={actionTemplate}></Column>
                        </DataTable>
                        <Paginator
                            first={first}
                            rows={paginationSize}
                            totalRecords={pagination.totalItems}
                            rowsPerPageOptions={[5, 10, 15, 25, 50]}
                            onPageChange={onPageChange}
                            template="PrevPageLink PageLinks NextPageLink RowsPerPageDropdown"
                            className="border-top-1 border-bottom-1"
                        />
                    </div>
                    {selectedRowData && (
                        <>
                            {windowWidth > 1248 && <div className={classNames('card widget-table col-12 md:col-12 align-self-start sticky top-0')}>
                                <AudioControlListDetails setSelectedRowData={setSelectedRowData} selectedRowData={selectedRowData} windowWidth={windowWidth}/>
                            </div>}

                            {windowWidth <= 1248 && <div>
                                <Dialog visible={mobileVisible} header={dialogHeader} className="monitoring-info" onHide={() => setMobileVisible(false)}>
                                    <AudioControlListDetails setSelectedRowData={setSelectedRowData} selectedRowData={selectedRowData}/>
                                </Dialog>
                            </div>}
                        </>
                    )}
                    <AudioControlDialog setSelectedRowData={setSelectedRowData}/>
                    <ConfirmDialog visible={visibleCopyMessage} onHide={() => setVisibleCopyMessage(false)}
                                   message="Бажаєте скопіювати анкету?"
                                   icon="pi pi-question-circle" acceptLabel="Продовжити" rejectLabel="Відмінити"
                                   accept={() => confirmCopy()}/>
                    <ConfirmDialog visible={visibleArchiveMessage} onHide={() => setVisibleArchiveMessage(false)}
                                   message="Анкету буде архівовано та деактивовано. Архівувати?"
                                   icon="pi pi-exclamation-triangle" acceptLabel="Продовжити" rejectLabel="Відмінити"
                                   accept={() => confirmArchiveOrUnarchive()}/>
                    <ConfirmDialog visible={visibleUnArchiveMessage} onHide={() => setVisibleUnArchiveMessage(false)}
                                   message="Анкету буде розархівовано! Розархівувати?"
                                   icon="pi pi-exclamation-triangle" acceptLabel="Продовжити" rejectLabel="Відмінити"
                                   accept={() => confirmArchiveOrUnarchive()}/>
                </div>
            </div>
        </div>
    );
};

export default AudioControlList;
